<template>
  <div class="nx-signing-modal-method-p12">
    <h4>{{$t('PrepareToken')}} </h4>

    <h5 class="mt-4" v-if="loading">
     {{$t('AskCertificate')}} 
    </h5>
    <h5 class="mt-4" v-else>{{$t('SelectCertificate')}}</h5>

    <div class="mt-4">
      <b-spinner v-if="loading" />
      <b-list-group v-else>
        <b-list-group-item
          v-for="cert of certs"
          :key="cert.alias"
          class="text-nowrap"
          button
          @click="sign(cert)"
        >
          <span>{{ cert.subjectDn }}</span> / <span>{{ cert.alias }}</span> /
          <span>{{ cert.expiredDate }}</span>
        </b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>

<script>
// import SignClient from '@nextore/nx-signing/src/api/sign-client.api';
import SignClient from '@/api/sign-client.api';
import { SignApi } from "@/api";


export default {
  props: {
    value: {}
  },
  data() {
    return {
      certs: [],
      loading: true,
      signClient: null
    };
  },
  async created() {

    this.signClient = new SignClient();

    try {
      const signClient = this.signClient;
      await signClient.init();
      const certs = await signClient.getUsbCerts();
      this.certs = certs.certs;
      this.loading = false;
    } catch (ex) {
      if (ex.response) {
        this.$emit('input', ex.response.data);
      } else if (ex.message) {
        this.$emit('input', ex.message);
      }

      this.$emit('fail');

      throw ex;
    }
  },
  methods: {
    async sign(cert) {
      const signClient = this.signClient;

      try {
        this.loading = true;
        const { digests } = this.value;
        let pdfsDigests = this.value.digests;


        let signatures = [];

        if (pdfsDigests && pdfsDigests.length > 0) {
          const data = await signClient.usbSignPdfBatch(cert.alias, pdfsDigests);
          const pdfsSignatures = data.data;
          const usbPdfCert = data.cert;
          let pdfsSignaturesMapped =  pdfsSignatures.map((x) => ({
            cert : usbPdfCert,
            fileID : -1,
            signature: x.signature,
            digest: x.digest
          }));

          signatures.push(...pdfsSignaturesMapped)
        }

        this.$emit('input', {
          ...this.value,
          signatures: signatures
        });
        this.$emit('next');

        this.loading = false;
      } catch (ex) {
         if (ex.response) {
          this.$emit('input', ex.response);
        } else if (ex.message) {
          this.$emit('input', ex.message);
        }

        this.$emit('fail');
        throw ex;
      }
    }
  },i18n: {
    messages: {
      en: {
        PrepareToken: 'Please prepare your token for signing',
        AskCertificate: 'The client program is going to ask for your certificate',
        SelectCertificate: 'Please select one of the following certificate'
      },
      zh_hk: {
        PrepareToken: '請準備好你的p12證書',
        AskCertificate: '客戶端程序將要求您提供證書',
        SelectCertificate: '請選擇以下證書'
      },
      zh_cn: {
        PrepareToken: '请准备好你的p12证书',
        AskCertificate: '客户端程序将要求您提供证书',
        SelectCertificate: '请选择以下证书'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-method-p12 {
  text-align: center;
}
</style>
